<template>
  <div>
    <table class="table" >
      <thead>
      <tr>
        <th>冷蔵庫ID</th>
        <th>会社名-拠点名-フロア</th>
        <th>配送員コメント</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="maintenance in maintenanceList">
        <td>{{maintenance.boxId}}</td>
        <td>{{maintenance.boxPlaceName}}</td>
        <td class="comment" v-text="maintenance.workerComment"></td>
        <td>
          <button
            class="btn"
            @click="showWorkerCommentDialog(maintenance.boxId)"
          >
            編集する
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <WorkerCommentDialog
      :isShowWorkerCommentDialog=isShowWorkerCommentDialog
      btnTitle="更新"
      :isShowCancelBtn="true"
      @close="closeWorkerCommentDialog"
      @cancel="cancelWorkerCommentDialog"
    ></WorkerCommentDialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import WorkerCommentDialog from '@/components/globals/WorkerCommentDialog';

  export default {
    name: 'CommentList',
    components: {
      WorkerCommentDialog,
    },
    created() {
      this.$parent.title = '配送員コメント一覧';
      this.$parent.imageName = '';
      this.$parent.showMaintenanceInformation = false;
      this.$parent.hasMaintenancne = false;
    },
    computed: {
      ...mapGetters([
        'maintenanceList',
      ]),
    },
    data() {
      return {
        isShowWorkerCommentDialog: false,
      };
    },
    methods: {
      showWorkerCommentDialog(boxId) {
        this.$store.dispatch('getMaintenanceData', { boxId: boxId })
          .then(() => { this.isShowWorkerCommentDialog = true; })
          .catch((e) => {
            if (e.status == 401) {
              alert(e.data.error.message);
              this.$router.push({ name: 'SignIn', replace: true });
              return;
            }
            alert(e.data.error.message);
          });
      },
      closeWorkerCommentDialog: function(comment) {
        this.$store.dispatch('setComment', { comment });
        this.$store.dispatch('updateWorkerComment')
          .then(() => { this.isShowWorkerCommentDialog = false; })
          .catch((e) => {
            if (e.status == 401) {
              alert(e.data.error.message);
              this.$router.push({ name: 'SignIn', replace: true });
              return;
            }
            alert(e.data.error.message);
          });
      },
      cancelWorkerCommentDialog: function() {
        this.isShowWorkerCommentDialog = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  div {
    padding-top: 1rem;

    td {
      &.comment {
        white-space: pre-wrap;
      }

      button {
        background: #CBDAF5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CommentList.vue?742ca603